import uuid from 'node-uuid'
import {apiUrl, apiOption, apiResponse, errorResponse} from '../core/fetchz'
import loading from '../core/redux/loading'
import config from '../config'

const NAMESPACE = 'Company'
export const LINKS_LOADED = NAMESPACE + '/LinksLoaded'
export const COMPANY_STREAM_LOADED = NAMESPACE + '/CompanyStreamLoaded'
export const COMPANY_STREAM_QUERIED = NAMESPACE + '/CompanyStreamQueried'
export const MINOR_COMPANY_STREAM_QUERIED = NAMESPACE + '/MinorCompanyStreamQueried'
export const COMPANY_LOADED = NAMESPACE + '/CompanyLoaded'
export const COMPANY_CONFIGS_LOADED = NAMESPACE + '/CompanyConfigsLoaded'
export const COMPANY_CONFIGS_QUERIED = NAMESPACE + '/CompanyConfigsQueried'
export const USER_STREAM_LOADED = NAMESPACE + '/UserStreamLoaded'
export const USER_CONFIGS_LOADED = NAMESPACE + '/UserConfigsLoaded'
export const USER_CONFIGS_QUERIED = NAMESPACE + '/UserConfigsQueried'
export const AGENCY_STREAM_LOADED = NAMESPACE + '/AgencyStreamLoaded'
export const AGENCY_STREAM_QUERIED = NAMESPACE + '/AgencyStreamQueried'
export const AGENCY_LOADED = NAMESPACE + '/AgencyLoaded'
export const SUBSIDIARY_STREAM_LOADED = NAMESPACE + '/SubsidiaryStreamLoaded'
export const SUBSIDIARY_STREAM_QUERIED = NAMESPACE + '/SubsidiaryStreamQueried'
export const REFERENCE_COMPANY_CMD_SENT = NAMESPACE + '/ReferenceCompanyCmdSent'
export const REFERENCE_AGENCY_CMD_SENT = NAMESPACE + '/ReferenceAgencyCmdSent'
export const REFERENCE_USER_CMD_SENT = NAMESPACE + '/ReferenceUserCmdSent'
export const UPDATE_AGENCY_CMD_SENT = NAMESPACE + '/UpdateAgencyCmdSent'
export const DELETE_AGENCY_CMD_SENT = NAMESPACE + '/DeleteAgencyCmdSent'
export const UPDATE_COMPANY_CMD_SENT = NAMESPACE + '/UpdateCompanyCmdSent'
export const IDENTIFY_COMPANY_CMD_SENT = NAMESPACE + '/IdentifyCompanyCmdSent'
export const REACTIVE_COMPANY_CMD_SENT = NAMESPACE + '/ReactiveCompanyCmdSent'
export const CANCEL_COMPANY_CMD_SENT = NAMESPACE + '/CancelCompanyCmdSent'
export const UPGRADE_COMPANY_TO_PREMIUM_ACCOUNT_CMD_SENT = NAMESPACE + '/UpgradeCompanyToPremiumAccountCmdSent'
export const DOWNGRADE_PREMIUM_ACCOUNT_CMD_SENT = NAMESPACE + '/DowngradePremiumAccountCmdSent'
export const UPGRADE_COMPANY_TO_STANDARD_ACCOUNT_CMD_SENT = NAMESPACE + '/UpgradeCompanyToStandardAccountCmdSent'
export const UPDATE_USER_CMD_SENT = NAMESPACE + '/UpdateUserCmdSent'
export const UPDATE_LOGIN_CMD_SENT = NAMESPACE + '/UpdateLoginCmdSent'
export const ASSOCIATE_USER_WITH_AGENCY_CMD_SENT = NAMESPACE + '/AssociateUserWithAgencyCmdSent'
export const DISSOCIATE_USER_FROM_AGENCY_CMD_SENT = NAMESPACE + '/DissociateUserFromAgencyCmdSent'
export const ASSOCIATE_USER_WITH_PATRIMONY_CMD_SENT = NAMESPACE + '/AssociateUserWithPatrimonyCmdSent'
export const DISSOCIATE_USER_FROM_PATRIMONY_CMD_SENT = NAMESPACE + '/DissociateUserFromPatrimonyCmdSent'
export const DISABLE_USER_CMD_SENT = NAMESPACE + '/DisableUserCmdSent'
export const DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_SENT = NAMESPACE + '/DowngradeExecutiveToPatrimonyManagerCmdSent'
export const SEND_ACTIVATION_EMAIL_DEMAND_SENT = NAMESPACE + '/SendActivationEmailDemandSent'
export const COMPANY_CONFIGS_SENT = NAMESPACE + '/CompanyConfigsSent'
export const USER_CONFIGS_SENT = NAMESPACE + '/UserConfigsSent'
// form actions
export const COMPANY_CRITERIA_UPDATED = NAMESPACE + '/CompanyCriteriaUpdated'
export const AGENCY_CRITERIA_UPDATED = NAMESPACE + '/AgencyCriteriaUpdated'
export const USER_CRITERIA_UPDATED = NAMESPACE + '/UserCriteriaUpdated'
export const MINOR_COMPANY_CRITERIA_UPDATED = NAMESPACE + '/MinorCompanyCriteriaUpdated'
export const MINOR_COMPANY_CRITERIA_RESET = NAMESPACE + '/MinorCompanyCriteriaReset'
export const REFERENCE_COMPANY_CMD_UPDATED = NAMESPACE + '/ReferenceCompanyCmdUpdated'
export const REFERENCE_AGENCY_CMD_UPDATED = NAMESPACE + '/ReferenceAgencyCmdUpdated'
export const REFERENCE_USER_CMD_UPDATED = NAMESPACE + '/ReferenceUserCmdUpdated'
export const UPDATE_AGENCY_CMD_UPDATED = NAMESPACE + '/UpdateAgencyCmdUpdated'
export const UPDATE_COMPANY_CMD_UPDATED = NAMESPACE + '/UpdateCompanyCmdUpdated'
export const IDENTIFY_COMPANY_CMD_UPDATED = NAMESPACE + '/IdentifyCompanyCmdUpdated'
export const UPDATE_USER_CMD_UPDATED = NAMESPACE + '/UpdateUserCmdUpdated'
export const UPDATE_LOGIN_CMD_UPDATED = NAMESPACE + '/UpdateLoginCmdUpdated'
export const DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_UPDATED = NAMESPACE + '/DowngradeExecutiveToPatrimonyManagerCmdUpdated'
export const COMPANY_CONFIGS_UPDATED = NAMESPACE + '/CompanyConfigsUpdated'
export const USER_CONFIGS_UPDATED = NAMESPACE + '/UserConfigsUpdated'

function array(array, properties) {
    array = [...array]
    Object.keys(properties).forEach((key) => array[key] = properties[key])
    return array
}

function reduceArray(result, array) {
    result.push(...array)
    return result
}

export const DEFAULT_QUERY = {
    range: {offset: 0, limit: 19}
}

export const DEFAULT_COMPANY_QUERY = {
    ...DEFAULT_QUERY,
    fullText: null,
    billingType: null,
    companyType: null,
    includeSubsidiaries: null
}

export const DEFAULT_AGENCY_QUERY = {
    ...DEFAULT_QUERY,
    companyUid: null,
    holdingUid: null,
    active: null
}

export const DEFAULT_USER_QUERY = {
    ...DEFAULT_QUERY,
    companyUid: null,
    active: null
}

export function loadLinks() {
    const query = {
        range: {offset: 0, limit: 0}
    }

    return loading(fetch(apiUrl(config.api.url + '/clientcompanies', query), apiOption())
    .then(apiResponse)
    .then(({json}) => {
        return {
            type: LINKS_LOADED,
            _links: json._links
        }
    }), LINKS_LOADED)
}

export function queryCompanyStream(companyQuery) {
    return loadCompanyStream(companyQuery, COMPANY_STREAM_QUERIED)
}

export function queryMinorCompanyStream(companyQuery) {
    return loadCompanyStream(companyQuery, MINOR_COMPANY_STREAM_QUERIED)
}

export function loadCompanyStream(companyQuery, action) {
    return loading((state) => {
        const {query, minorQuery} = state.company

        companyQuery = {
            ...DEFAULT_QUERY,
            ...(action && action.includes('Minor') && minorQuery || query),
            ...companyQuery
        }

        return fetch(apiUrl(config.api.url + '/clientcompanies', companyQuery), apiOption())
        .then(apiResponse)
        .then(({headers, json}) => {
            return {
                type: action || COMPANY_STREAM_LOADED,
                stream: json.result,
                range: headers.contentRange,
                _links: json._links,
                query: companyQuery
            }
        })

    }, action || COMPANY_STREAM_LOADED)
}

export function loadCompany(id) {
    return loading((state) => {
        const {company} = state.company
        id = id || (company && company.uid)

        const userQuery = {
            range: {offset: 0, limit: 0}
        }

        const subsidiaryQuery = {
            range: {offset: 0, limit: 0}
        }

        const agencyQuery = {
            active: true
        }

        const companyPromise = fetch(config.api.url + '/clientcompanies/' + id, apiOption()).then(apiResponse)
        const agenciesPromise = fetch(apiUrl(config.api.url + '/clientcompanies/' + id + '/agencies', agencyQuery), apiOption()).then(apiResponse)
        const usersPromise = fetch(apiUrl(config.api.url + '/clientcompanies/' + id + '/users', userQuery), apiOption()).then(apiResponse)
        const subsidiariesPromise = fetch(apiUrl(config.api.url + '/clientcompanies/' + id + '/subsidiaries', subsidiaryQuery), apiOption()).then(apiResponse)

        return Promise.all([companyPromise, agenciesPromise, usersPromise, subsidiariesPromise]).then(([companyResponse, agenciesResponse, usersResponse, subsidiariesResponse]) => {
            return {
                type: COMPANY_LOADED,
                company: companyResponse.json,
                companyAgencies: array(agenciesResponse.json.result, {
                    count: agenciesResponse.headers.contentRange.count,
                    _links: agenciesResponse.json._links
                }),
                companyUsers: {
                    count: usersResponse.headers.contentRange.count,
                    _links: usersResponse.json._links
                },
                companySubsidiaries: {
                    count: subsidiariesResponse.headers.contentRange.count,
                    _links: subsidiariesResponse.json._links
                }
            }
        })
    }, COMPANY_LOADED)
}

export function queryCompanyConfigs() {
    return loadCompanyConfigs(COMPANY_CONFIGS_QUERIED)
}

export function loadCompanyConfigs(action) {
    return loading((state) => {
        const {company} = state.company

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/configs', apiOption())
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: action || COMPANY_CONFIGS_LOADED,
                companyConfigs: json
            }
        })
    }, action || COMPANY_CONFIGS_LOADED)
}

export function loadUserStream(userQuery) {
    return loading((state) => {
        const {company} = state.company
        const {query} = state.company.user

        userQuery = {
            ...DEFAULT_QUERY,
            companyUid: company && company.uid,
            ...query,
            ...userQuery
        }
        
        const {companyUid, ...apiUserQuery} = userQuery

        return fetch(apiUrl(config.api.url + '/clientcompanies/' + companyUid + '/users', apiUserQuery), apiOption())
        .then(apiResponse)
        .then(({headers, json}) => {
            return {
                type: USER_STREAM_LOADED,
                stream: json.result,
                range: headers.contentRange,
                query: userQuery
            }
        })
    }, USER_STREAM_LOADED)
}

export function queryUserConfigs(userId) {
    return loadUserConfigs(userId, USER_CONFIGS_QUERIED)
}

export function loadUserConfigs(userId, action) {
    return loading(fetch(config.api.url + '/users/' + userId + '/configs', apiOption())
    .then(apiResponse)
    .then(({json}) => {
        return {
            type: action || USER_CONFIGS_LOADED,
            userConfigs: json
        }
    }), action || USER_CONFIGS_LOADED)
}

export function queryAgencyStream(agencyQuery) {
    return loadAgencyStream(agencyQuery, AGENCY_STREAM_QUERIED)
}

export function loadAgencyStream(agencyQuery, action) {
    return loading((state) => {
        const {company} = state.company
        const {query} = state.company.agency

        agencyQuery = {
            ...DEFAULT_AGENCY_QUERY,
            companyUid: company && company.uid,
            ...query,
            ...agencyQuery
        }
        
        const {companyUid, ...apiAgencyQuery} = agencyQuery

        return fetch(apiUrl(config.api.url + '/clientcompanies/' + companyUid + '/agencies', apiAgencyQuery), apiOption())
        .then(apiResponse)
        .then(({headers, json}) => {
            return {
                type: action || AGENCY_STREAM_LOADED,
                stream: json.result,
                range: headers.contentRange,
                query: agencyQuery
            }
        })
    }, action || AGENCY_STREAM_LOADED)
}

export function queryHoldingAgencyStream(agencyQuery) {
    return loadHoldingAgencyStream(agencyQuery, AGENCY_STREAM_QUERIED)
}

export function loadHoldingAgencyStream(agencyQuery, action) {
    return loading((state) => {
        const {company} = state.company
        const {query} = state.company.agency

        agencyQuery = {
            ...DEFAULT_AGENCY_QUERY,
            holdingUid: company && company.uid,
            ...query,
            ...agencyQuery
        }
        
        const {holdingUid, ...apiAgencyQuery} = agencyQuery

        return fetch(config.api.url + '/clientcompanies/' + holdingUid + '/subsidiaries', apiOption())
        .then(apiResponse)
        .then(({json}) => {
            const subsidiaries = json.result
            const agenciesPromises = subsidiaries.map((s) => fetch(apiUrl(config.api.url + '/clientcompanies/' + s.uid + '/agencies', apiAgencyQuery), apiOption()).then(apiResponse))
            return Promise.all(agenciesPromises)
        }).then((agenciesResponses) => {
            return {
                type: action || AGENCY_STREAM_LOADED,
                stream: agenciesResponses.map((r) => r.json.result).reduce(reduceArray),
                range: null,
                query: agencyQuery
            }
        })
    }, action || AGENCY_STREAM_LOADED)
}

export function loadAgency(companyId, agencyId) {
    return loading((state) => {
        const {agency} = state.company.agency
        companyId = companyId || (agency && agency.company.uid)
        agencyId = agencyId || (agency && agency.uid)

        return fetch(config.api.url + '/clientcompanies/' + companyId + '/agencies/' + agencyId, apiOption())
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: AGENCY_LOADED,
                agency: json
            }
        })
    }, AGENCY_LOADED)
}

export function querySubsidiaryStream(subsidiaryQuery) {
    return loadSubsidiaryStream(subsidiaryQuery, SUBSIDIARY_STREAM_QUERIED)
}

export function loadSubsidiaryStream(subsidiaryQuery, action) {
    return loading((state) => {
        const {company} = state.company
        const {query} = state.company.subsidiary
        
        subsidiaryQuery = {
            ...DEFAULT_QUERY,
            holdingUid: company && company.uid,
            ...query,
            ...subsidiaryQuery
        }

        const {holdingUid, ...apiSubsidiaryQuery} = subsidiaryQuery

        return fetch(apiUrl(config.api.url + '/clientcompanies/' + holdingUid + '/subsidiaries', apiSubsidiaryQuery), apiOption())
        .then(apiResponse)
        .then(({headers, json}) => {
            return {
                type: action || SUBSIDIARY_STREAM_LOADED,
                stream: json.result,
                range: headers.contentRange,
                query: subsidiaryQuery
            }
        })
    }, action || SUBSIDIARY_STREAM_LOADED)
}

export function sendReferenceCompanyCmd() {
    return loading((state) => {
        const {referenceCompanyCmd} = state.company
        const {label, ...cmd} = referenceCompanyCmd

        const option = {
            body: {
                processUid: uuid.v4(),
                createdDate: new Date().toISOString().slice(0,10),
                name: label,
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/clientcompanies', apiOption(option))
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: REFERENCE_COMPANY_CMD_SENT,
                events: json.events
            }
        })
    }, REFERENCE_COMPANY_CMD_SENT)
}

export function sendReferenceAgencyCmd() {
    return loading((state) => {
        const {referenceAgencyCmd, company} = state.company
        const {agency: {ref, label, emails, phones, ...agency}} = referenceAgencyCmd
        
        const option = {
            body: {
                processUid: uuid.v4(),
                createdDate: new Date().toISOString().slice(0,10),
                commandType: 'CreateAgency',
                agency: {
                    extName: ref,
                    name: label,
                    emails: emails || [],
                    phones: phones || [],
                    ...agency
                }
            }
        }

        return fetch(config.api.event.url + '/clientcompanies/' + company.uid + '/agencies', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REFERENCE_AGENCY_CMD_SENT
            }
        })
    }, REFERENCE_AGENCY_CMD_SENT)
}

export function sendReferenceUserCmd() {
    return loading((state) => {
        const {referenceUserCmd} = state.company
        const {managedPatrimonies} = referenceUserCmd
        
        const option = {
            body: {
                processUid: uuid.v4(),
                ...referenceUserCmd,
                managedPatrimonies: managedPatrimonies && managedPatrimonies.map((a) => a.uid)
            }
        }

        return fetch(config.api.event.url + '/users', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REFERENCE_USER_CMD_SENT
            }
        })
    }, REFERENCE_USER_CMD_SENT)
}

export function sendUpdateAgencyCmd() {
    return loading((state) => {
        const {updateAgencyCmd} = state.company
        const {agency: {uid, company, ref, label, emails, phones, ...agency}} = updateAgencyCmd
        
        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                updatedDate: new Date().toISOString().slice(0,10),
                commandType: 'UpdateAgency',
                agency: {
                    extName: ref,
                    name: label,
                    emails: emails || [],
                    phones: phones || [],
                    ...agency
                }
            }
        }

        return fetch(config.api.event.url + '/clientcompanies/' + company.uid + '/agencies/' + uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UPDATE_AGENCY_CMD_SENT
            }
        })
    }, UPDATE_AGENCY_CMD_SENT)
}

export function sendUpdateCompanyCmd() {
    return loading((state) => {
        const {updateCompanyCmd, company} = state.company
        const {label, ...cmd} = updateCompanyCmd
        
        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                updatedDate: new Date().toISOString().slice(0,10),
                name: label,
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/clientcompanies/' + company.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UPDATE_COMPANY_CMD_SENT
            }
        })
    }, UPDATE_COMPANY_CMD_SENT)
}

export function sendIdentifyCompanyCmd() {
    return loading((state) => {
        const {identifyCompanyCmd, company} = state.company
        
        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'IdentifyCompany',
                ...identifyCompanyCmd
            }
        }

        return fetch(config.api.event.url + '/clientcompanies/' + company.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: IDENTIFY_COMPANY_CMD_SENT
            }
        })
    }, IDENTIFY_COMPANY_CMD_SENT)
}

export function sendReactiveCompanyCmd() {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                reactivatedDate: new Date().toISOString().slice(0,10),
                commandType: 'ReactiveCompany'
            }
        }

        return fetch(config.api.event.url + '/clientcompanies/' + company.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REACTIVE_COMPANY_CMD_SENT
            }
        })
    }, REACTIVE_COMPANY_CMD_SENT)
}

export function sendCancelCompanyCmd() {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                canceledDate: new Date().toISOString().slice(0,10),
                commandType: 'CancelCompany'
            }
        }

        return fetch(config.api.event.url + '/clientcompanies/' + company.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: CANCEL_COMPANY_CMD_SENT
            }
        })
    }, CANCEL_COMPANY_CMD_SENT)
}

export function sendUpgradeCompanyToPremiumAccountCmd() {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                upgradedDate: new Date().toISOString().slice(0,10),
                commandType: 'UpgradeCompanyToPremiumAccount'
            }
        }

        return fetch(config.api.event.url + '/clientcompanies/' + company.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UPGRADE_COMPANY_TO_PREMIUM_ACCOUNT_CMD_SENT
            }
        })
    }, UPGRADE_COMPANY_TO_PREMIUM_ACCOUNT_CMD_SENT)
}

export function sendDowngradePremiumAccountCmd() {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                downgradedDate: new Date().toISOString().slice(0,10),
                commandType: 'DowngradePremiumAccount'
            }
        }

        return fetch(config.api.event.url + '/clientcompanies/' + company.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: DOWNGRADE_PREMIUM_ACCOUNT_CMD_SENT
            }
        })
    }, DOWNGRADE_PREMIUM_ACCOUNT_CMD_SENT)
}

export function sendUpgradeCompanyToStandardAccountCmd() {
    return loading((state) => {
        const {company} = state.company

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                upgradedDate: new Date().toISOString().slice(0,10),
                commandType: 'UpgradeCompanyToStandardAccount'
            }
        }

        return fetch(config.api.event.url + '/clientcompanies/' + company.uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UPGRADE_COMPANY_TO_STANDARD_ACCOUNT_CMD_SENT
            }
        })
    }, UPGRADE_COMPANY_TO_STANDARD_ACCOUNT_CMD_SENT)
}

export function sendDeleteAgencyCmd(companyId, agencyId) {
    const option = {
        method: 'PATCH',
        body: {
            processUid: uuid.v4(),
            deletedDate: new Date().toISOString().slice(0,10),
            commandType: 'DeleteAgency',
            agencyUid: agencyId
        }
    }

    return loading(fetch(config.api.event.url + '/clientcompanies/' + companyId + '/agencies/' + agencyId, apiOption(option))
    .then(errorResponse)
    .then(() => {
        return {
            type: DELETE_AGENCY_CMD_SENT
        }
    }), DELETE_AGENCY_CMD_SENT)
}

export function sendUpdateUserCmd() {
    return loading((state) => {
        const {updateUserCmd} = state.company
        const {uid, ...cmd} = updateUserCmd
        
        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'UpdateUser',
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/users/' + uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UPDATE_USER_CMD_SENT
            }
        })
    }, UPDATE_USER_CMD_SENT)
}

export function sendUpdateLoginCmd() {
    return loading((state) => {
        const {updateLoginCmd} = state.company
        const {uid, ...cmd} = updateLoginCmd
        
        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'UpdateLogin',
                ...cmd
            }
        }

        return fetch(config.api.event.url + '/users/' + uid, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UPDATE_LOGIN_CMD_SENT
            }
        })
    }, UPDATE_LOGIN_CMD_SENT)
}

export function sendAssociateUserWithAgencyCmd(userId, agencyId) {
    const option = {
        method: 'PATCH',
        body: {
            processUid: uuid.v4(),
            commandType: 'AssociateUserWithAgency',
            agencyUid: agencyId
        }
    }

    return loading(fetch(config.api.event.url + '/users/' + userId, apiOption(option))
    .then(errorResponse)
    .then(() => {
        return {
            type: ASSOCIATE_USER_WITH_AGENCY_CMD_SENT
        }
    }), ASSOCIATE_USER_WITH_AGENCY_CMD_SENT)
}

export function sendDissociateUserFromAgencyCmd(userId, agencyId) {
    const option = {
        method: 'PATCH',
        body: {
            processUid: uuid.v4(),
            commandType: 'DissociateUserFromAgency',
            agencyUid: agencyId
        }
    }

    return loading(fetch(config.api.event.url + '/users/' + userId, apiOption(option))
    .then(errorResponse)
    .then(() => {
        return {
            type: DISSOCIATE_USER_FROM_AGENCY_CMD_SENT
        }
    }), DISSOCIATE_USER_FROM_AGENCY_CMD_SENT)
}

export function sendAssociateUserWithPatrimonyCmd(userId, patrimonyId) {
    const option = {
        method: 'PATCH',
        body: {
            processUid: uuid.v4(),
            commandType: 'AssociateUserWithPatrimony',
            patrimonyUid: patrimonyId
        }
    }

    return loading(fetch(config.api.event.url + '/users/' + userId, apiOption(option))
    .then(errorResponse)
    .then(() => {
        return {
            type: ASSOCIATE_USER_WITH_PATRIMONY_CMD_SENT
        }
    }), ASSOCIATE_USER_WITH_PATRIMONY_CMD_SENT)
}

export function sendDissociateUserFromPatrimonyCmd(userId, patrimonyId) {
    const option = {
        method: 'PATCH',
        body: {
            processUid: uuid.v4(),
            commandType: 'DissociateUserFromPatrimony',
            patrimonyUid: patrimonyId
        }
    }

    return loading(fetch(config.api.event.url + '/users/' + userId, apiOption(option))
    .then(errorResponse)
    .then(() => {
        return {
            type: DISSOCIATE_USER_FROM_PATRIMONY_CMD_SENT
        }
    }), DISSOCIATE_USER_FROM_PATRIMONY_CMD_SENT)
}

export function sendDisableUserCmd(userId) {
    const option = {
        method: 'PATCH',
        body: {
            processUid: uuid.v4(),
            commandType: 'DisableUser'
        }
    }

    return loading(fetch(config.api.event.url + '/users/' + userId, apiOption(option))
    .then(errorResponse)
    .then(() => {
        return {
            type: DISABLE_USER_CMD_SENT
        }
    }), DISABLE_USER_CMD_SENT)
}

export function sendDowngradeExecutiveToPatrimonyManagerCmd(userId) {
    return loading((state) => {
        const {downgradeExecutiveToPatrimonyManagerCmd} = state.company
        const {managedPatrimonies} = downgradeExecutiveToPatrimonyManagerCmd

        const option = {
            method: 'PATCH',
            body: {
                processUid: uuid.v4(),
                commandType: 'DowngradeExecutiveToPatrimonyManager',
                ...downgradeExecutiveToPatrimonyManagerCmd,
                managedPatrimonies: managedPatrimonies && managedPatrimonies.map((a) => a.uid)
            }
        }

        return fetch(config.api.event.url + '/users/' + userId, apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_SENT
            }
        })
    }, DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_SENT)
}

export function sendSendActivationEmailDemand(userId) {
    const option = {
        body: {
            userUid: userId
        }
    }

    return fetch(config.api.url + '/sendActivationEmailDemand', apiOption(option))
    .then(errorResponse)
    .then(() => {
        return {
            type: SEND_ACTIVATION_EMAIL_DEMAND_SENT
        }
    })
}

export function sendCompanyConfigs() {
    return loading((state) => {
        const {company, companyConfigs} = state.company

        const option = {
            method: 'PATCH',
            body: companyConfigs
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/configs', apiOption(option))
        .then(apiResponse)
        .then(() => {
            return {
                type: COMPANY_CONFIGS_SENT
            }
        })
    }, COMPANY_CONFIGS_SENT)
}

export function sendUserConfigs(userId) {
    return loading((state) => {
        const {userConfigs} = state.company.user

        const option = {
            method: 'PATCH',
            body: userConfigs
        }

        return fetch(config.api.url + '/users/' + userId + '/configs', apiOption(option))
        .then(apiResponse)
        .then(() => {
            return {
                type: USER_CONFIGS_SENT
            }
        })
    }, USER_CONFIGS_SENT)
}

export function updateReferenceCompanyCmd(cmd) {
    return {
        type: REFERENCE_COMPANY_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateReferenceUserCmd(cmd) {
    return {
        type: REFERENCE_USER_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateUpdateAgencyCmd(cmd) {
    return {
        type: UPDATE_AGENCY_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateUpdateCompanyCmd(cmd) {
    return {
        type: UPDATE_COMPANY_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateUpdateUserCmd(cmd) {
    return {
        type: UPDATE_USER_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateUpdateLoginCmd(cmd) {
    return {
        type: UPDATE_LOGIN_CMD_UPDATED,
        cmd: cmd
    }
}

export function updateMinorCompanyCriteria(cmd) {
    return {
        type: MINOR_COMPANY_CRITERIA_UPDATED,
        cmd: cmd
    }
}

export function resetMinorCompanyCriteria(cmd) {
    return {
        type: MINOR_COMPANY_CRITERIA_RESET,
        cmd: cmd
    }
}


// WEBPACK FOOTER //
// ./lib/company/actions.js